import { useEffect, useContext } from "react";
import { useLocation, useHistory } from "react-router";
import { AppContext } from "../../../App";
import useFetchData from "../../../../api/apiHelpers";
import api from "../../../../api/api";

const useError = (pathnameType: string) => {
    const handler = useFetchData();
    let id = pathnameType.substring(1, 6);
    let type = pathnameType.slice(6);
    const { dispatchAppData } = useContext(AppContext);
    const history = useHistory();
    const { pathname } = useLocation();

    useEffect(() => {
        if (type === "/band-error") {
            setTimeout(() => {
                dispatchAppData({ gifTrigger: true });
            }, 3800);
            setTimeout(() => {
                history.push(pathname.replace("/band-error", ""));
            }, 3900);
        } else if (type === "/kiosk-error") {
            const connectAgain = setInterval(() => {
                handler(async () => {
                    const response = await api.login(id);
                    if (response.status === 200) {
                        dispatchAppData({ loginData: response });
                        dispatchAppData({ networkError: false });
                        clearInterval(connectAgain);
                        setTimeout(() => {
                            dispatchAppData({ gifTrigger: true });
                        }, 1000);
                        setTimeout(() => {
                            history.push(pathname.replace("/kiosk-error", ""));
                        }, 1100);
                        dispatchAppData({ cardAtKioskResponding: false });
                    }
                });
            }, 20000);
        }
    }, []);

    return {};
};

export default useError;
